"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amntRe = void 0;
var amntRe = function (groupName, currGroupName) {
    return "".concat(currGroupName ? "(?<".concat(currGroupName, ">\\D+)") : '', "(?<").concat(groupName, ">\\d+(,\\d{3})*(\\.\\d+)?)");
};
exports.amntRe = amntRe;
